(function( $ ){

	var contentBuilder = function() {
		
		var me = this;
		var el, $el;
		var busy = false;
		
		this.settings = {
			section: 'section',
		}
		
		this.init = function( options ) 
		{
			$.extend(true, me.settings, options, $(this).data());
			me.el = this;
			me.$el = $(this);
			
			
		}
	}
	
	$.fn.contentBuilder = function( options ) {
		return this.each(function() 
		{
			var newContentBuilder = new contentBuilder();
			newContentBuilder.init.call(this, options);
			$(this).data('contentBuilder', newContentBuilder);
		});
	  };

})( jQuery );